import React, { Component } from 'react';
import "./about.css"
class AboutUs extends Component {
     
    constructor(props) {
        super(props);
        
        this.state = {
       
          noerorrpage :  true
        };
        
    
      }
    componentWillMount(){
        this.props.noerorrpage(this.state.noerorrpage)
    }
  render() {
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (
            <div className="AboutUs-page"> 
               <div className="AboutUs-body-radus-sub">
                <br/>
                  <h1 class="AboutUs-Title">About Us</h1>
                  <br/>
                  <p className="AboutUs-par-head">We are a team of doers on a mission to improve the payment experience for everyone.</p>
                  
               </div>
               <div className="AboutUs-image-body-full">
                  <div className="AboutUs-image-head">
                     
                    <img src="https://res.cloudinary.com/easywaya/image/upload/v1537477932/42164731_1927823140853336_3419030160752508928_n_z0qflb.png"/>
                  </div>
               </div>    
               <div className="AboutUs-body-bio-full">
                     <h4 class="AboutUs-body-bio-head">What we do</h4>
                     <h4 class="Paragraph-Subtitle Paragraph-Subtitle--dark">To truly experience life globally, people need to be able to navigate the 
                     world without letting borders dictate the way their money moves. Flywire is the world’s money engine,
                      removing boundaries and enabling the global payment and receivables process through seamless
                       transaction experiences and flexible solutions.<br/><br/>We make the complex simple by bringing visibility and convenience into our
                      process while working closely with businesses and organizations to power the global economy.</h4> 
               </div>
             <div className="AboutUs-values-body-full">
                <div className="AboutUs-values-body-sub">
                     <div class="AboutUs-values-head">Our values</div>
                    <div className="columns">
                        <div className="column is-half">
                            <div className="columns">
                              <div className="column is-one-fifth">
                                <div className="AboutUs-values-font">
                                      
                                <i className="fas fa-magic"></i>
                                </div>
                              </div>
                              <div className="column AboutUs-values-para">
                                 <div class="AboutUs-values-Title">Authenticity</div>
                                 <p>We never compromise on integrity, honesty, and kindness. 
                                   We believe in staying true to yourself and respecting colleagues for doing the same.</p>
                              </div>
                           
                            </div>
                        </div>
                        <div className="column">
                        <div className="columns">
                              <div className="column is-one-fifth">
                                <div className="AboutUs-values-font">
                                     
                                      <i className="fas fa-lightbulb"></i>
                                </div>
                              </div>
                              <div className="column AboutUs-values-para">
                                 <div class="AboutUs-values-Title">Execution</div>
                                 <p>We understand there’s always room for improvement. It’s all
                                    about thinking, questioning, developing, and changing . . . again and again.</p>
                              </div>
                           
                            </div>
                        </div>
                        
                    </div>

                    <div className="columns">
                        <div className="column is-half">
                            <div className="columns">
                              <div className="column is-one-fifth">
                                <div className="AboutUs-values-font">
                                     <i className="fas fa-cogs"></i>
                                </div>
                              </div>
                              <div className="column AboutUs-values-para">
                                 <div class="AboutUs-values-Title">Execution</div>
                                 <p>We take calculated risks and make smart decisions quickly, 
                                   because we know progress comes from masterful execution.</p>
                              </div>
                           
                            </div>
                        </div>
                        <div className="column">
                        <div className="columns">
                              <div className="column is-one-fifth">
                                <div className="AboutUs-values-font">
                                <i className="fas fa-check-circle"></i>
                                </div>
                              </div>
                              <div className="column AboutUs-values-para">
                                 <div className="AboutUs-values-Title">Fulfillment</div>
                                 <p>Work energizes and engages you, bringing both personal and
                                    professional satisfaction. When you’re fulfilled, challenges are welcomed..</p>
                              </div>
                           
                            </div>
                        </div>
                        
                    </div>
                  



                </div>
                 
             </div>
             <div className="AboutUs-team-body">
                <div className="AboutUs-team-sub">
                       <div className="AboutUs-team-Title">Our team</div>
                      {/* <div className="columns">
                        <div className="column is-half">
                           <div className="AboutUs-team-image-body">
                              <div className="AboutUs-team-image">
                                  <img src="https://us.123rf.com/450wm/goodluz/goodluz1206/goodluz120600653/14023387-senior-man-standing-on-white-background-with-arms-crossed.jpg?ver=6"  />
                              </div>
                            
                           </div>
                        </div>
                        <div className="column"></div>
                        <div className="column">Auto</div>
                      </div> */}
                      <div class="columns">
                        <div class="column is-one-third">
                        <div className="AboutUs-team-image-body">
                              <div className="AboutUs-team-image">
                                  <img src="https://us.123rf.com/450wm/goodluz/goodluz1206/goodluz120600653/14023387-senior-man-standing-on-white-background-with-arms-crossed.jpg?ver=6"  />
                              </div>
                              <div class="AboutUs-team-Info-body">
                                  <div class="AboutUs-team-Info-Name">Mike Ellis</div>
                                  <div class="AboutUs-team-Info-JobTitle">Chief Financial Officer</div> 
                                </div>
                           </div>
                        </div>
                        <div class="column">
                        <div className="AboutUs-team-image-body">
                              <div className="AboutUs-team-image">
                                  <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRT3imCzNtXB5AsUq_fw2oqMKQHHq-EADKkURtS0lSi6XW3quwnvw"  />
                              </div>
                              <div class="AboutUs-team-Info-body">
                                  <div class="AboutUs-team-Info-Name">Mike Ellis</div>
                                  <div class="AboutUs-team-Info-JobTitle">Chief Financial Officer</div> 
                                </div>
                           </div>
                        </div>
                        <div class="column">
                          <div className="AboutUs-team-image-body">
                              <div className="AboutUs-team-image">
                                  <img src="https://us.123rf.com/450wm/goodluz/goodluz1206/goodluz120600653/14023387-senior-man-standing-on-white-background-with-arms-crossed.jpg?ver=6"  />
                              </div>
                              <div class="AboutUs-team-Info-body">
                                  <div class="AboutUs-team-Info-Name">Mike Ellis</div>
                                  <div class="AboutUs-team-Info-JobTitle">Chief Financial Officer</div> 
                                </div>
                            
                           </div>
                        </div>
                      </div>

                </div>

             </div>
             
        <footer className="footer">
          
          <div className="search-footer-body-full">
            <div className="columns">
              <div className="column ">
                 <div className="search-footer-body">
                    <h5 className="search-footer-Menu-Title">Uvune</h5>
                    <br/>
                    <ul className="search-footer-Menu-list" >
                      <li>About</li>
                      <li>Careers</li>
                      {/* <li>Contact</li> */}
                      <li>Terms of Use</li>
                      {/* <li>Privacy Policy</li>
                      <li>Security Policy</li> */}
                    </ul>  
                 </div>
              </div>
              <div className="column">
                 <h5 className="search-footer-Menu-Title">Solutions</h5>
                    <br/>
                    <ul className="search-footer-Menu-list" >
                      <li>Education</li>
                      {/* <li>Healthcare</li>
                      <li>Business</li>
                      <li>Platform</li> */}
                    
                    </ul> 
              </div>
              <div className="column">
                 <h5 className="search-footer-Menu-Title">Community</h5>
                    <br/>
                  <ul className="search-footer-Menu-list" >
                      <li>Blog & News</li>
                      {/* <li>Engineering</li> */}
                      <li>Twitter</li>
                      <li>Facebook</li>
                      {/* <li>Linkedin</li> */}
                      
                  </ul> 
              </div>
              <div className="column">
                  <h5 className="search-footer-Menu-Title"></h5>
                    <br/>
                  <ul className="search-footer-Menu-list" >
                      <li>
                        <img width="50" src="http://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png"/>
                      </li>
                      <li>
                        <img width="50" src="https://res.cloudinary.com/easywaya/image/upload/v1524426443/12829476_1065330896870118_4143080475571245991_o_qh9gzs.jpg"/>
                      </li>  
                  </ul> 
              </div>
            </div>
           
          </div>
          
     
    </footer>
    <div className="search-footer-body-sub">
              Copyright ©Uvune. 2009-2018 All rights reserved. Uvune is a trademark of Uvune Corporation.
    </div>
             
           </div>     

    )

}





}

export default AboutUs;


// WEBPACK FOOTER //
// ./src/component/page/about.js